/**
 * The user-visible message a submission becomes.
 *
 * Mirrors `answer_content` in `app/clarifications.py`. The server's version is
 * authoritative — it is what gets persisted and prompted — but the browser needs
 * the same string to show the turn optimistically before the stream starts,
 * rather than a blank bubble that fills in a second later.
 */
export function clarificationAnswerText(card, answers) {
  const lines = ['Clarification answers:']
  for (const question of card?.questions ?? []) {
    const value = answers?.[question?.id]
    if (value) lines.push(`- ${question.question}: ${value}`)
  }
  return lines.length > 1 ? lines.join('\n') : ''
}
